import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
// import * as XLSX from 'xlsx';


import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import {Customer, ICustomer} from '../../shared/model/customer.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IStateCity} from '../../shared/model/stateCity';

type EntityResponseType = HttpResponse<ICustomer>;
type EntityArrayResponseType = HttpResponse<ICustomer[]>;
// import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({providedIn: 'root'})
export class CustomerService {
  public resourceUrl = SERVER_API_URL + 'api/customers';
  public resourceUrl_employee = SERVER_API_URL + 'api/customers-employee';

  constructor(protected http: HttpClient) {
  }

  create(customer: ICustomer): Observable<EntityResponseType> {
    return this.http.post<ICustomer>(this.resourceUrl, customer, {observe: 'response'});
  }
  assign(customer: ICustomer): Observable<EntityResponseType> {
    return this.http.post<ICustomer>(this.resourceUrl+'-assign', customer, {observe: 'response'});
  }

  update(customer: ICustomer): Observable<EntityResponseType> {
    return this.http.put<ICustomer>(this.resourceUrl, customer, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ICustomer>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  findByIdWithEmId(id: number): Observable<EntityResponseType> {
    return this.http.get<ICustomer>(`${this.resourceUrl_employee}/${id}`, {observe: 'response'});
  }

  findMyCustomerCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findCustomerMonthly(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<ICustomer>(`${this.resourceUrl + '-monthly/'+param}`, {observe: 'response'});
  }

  findCustomerMonthlyByType(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<ICustomer>(`${this.resourceUrl + '-monthly-type/'+param}`, {observe: 'response'});
  }
  findCustomersMonthlyByTypeBelfeal(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<ICustomer>(`${this.resourceUrl + '-monthly-type-belfeal/'+param}`, {observe: 'response'});
  }
  findCustomersMonthlyByTypeArchive(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<ICustomer>(`${this.resourceUrl + '-monthly-type-archive/'+param}`, {observe: 'response'});
  }
  findCustomersMonthlyByTypeSarenakh(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<ICustomer>(`${this.resourceUrl + '-monthly-type-sarenakh/'+param}`, {observe: 'response'});
  }

  findTopCustomersByProjects(limit: number = 8): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(`${this.resourceUrl}-top-by-projects`, {
      params: {limit: String(limit)},
      observe: 'response'
    });
  }

  findTopEmployeesByLeads(limit: number = 8): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(`${this.resourceUrl}-top-employees-leads`, {
      params: {limit: String(limit)},
      observe: 'response'
    });
  }

  findTopEmployeesByConversions(limit: number = 8): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(`${this.resourceUrl}-top-employees-conversions`, {
      params: {limit: String(limit)},
      observe: 'response'
    });
  }

  findCustomerCount(): Observable<HttpResponse<any>> {

    return this.http
      .get<any>(this.resourceUrl + '-count', {observe: 'response'});
  }
  getCustomerCountWithStatus(req?: any): Observable<HttpResponse<any>> {
    const options = createRequestOption(req);

    return this.http
      .get<any>(this.resourceUrl + '-count-status-report', {params: options, observe: 'response'});
  }

  getArchiveCustomerCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(this.resourceUrl + '-count-archive-report', {observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  searchAnutocomplete(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }

  // searchAnutocomplete(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<ICustomer[]>( SERVER_API_URL +'api/search/sample5', {params: options, observe: 'response'});
  // }
  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search-list-menu', {params: options, observe: 'response'});
  }
 searchAdvanced(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search-advanced', {params: options, observe: 'response'});
  }

reportAdvanced(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-report-advanced', {params: options, observe: 'response'});
  }


  searchReportByTypeDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }

  searchByTerm(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search-term', {params: options, observe: 'response'});
  }

  searchArchive(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-archive-search', {params: options, observe: 'response'});
  }

  searchDailyWithDetail(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-search-report-last-daily', {params: options, observe: 'response'});
  }

  searchDeleted(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-deleted-search', {params: options, observe: 'response'});
  }

  getCustomerNotification(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomer[]>(this.resourceUrl + '-notifications', {params: options, observe: 'response'});
  }


  getStates(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IStateCity[]>( SERVER_API_URL + 'api/stateCities/getStates', {params: options, observe: 'response'});
  }
  getCities(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IStateCity[]>( SERVER_API_URL + 'api/stateCities/getCities', {params: options, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  getOrderHistory(orderObjectId: any): Observable<HttpResponse<any>>{
    return this.http.get(`${this.resourceUrl + '/project-history'}/${orderObjectId}`, {observe: 'response'});
  }

  rejectionToPreviousSteps(orderObjectId: any, status: any): Observable<any>{
    const data = {orderObjectId: orderObjectId, status: status };
    return this.http.get(`${SERVER_API_URL  + 'api/project-rejection'}` , {params: data});
  }


  // public exportAsExcelFile(json: any[], excelFileName: string): void {
  //   // // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }
  //
  // public exportAsExcelFile2(json: Customer[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }
  //
  // private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE
  //   });
  //   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  // }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // alert(' json == ' + json.length);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
